module.exports = __webpack_public_path__ + "img/deviceBorrow-mine-bar-4.56beb8e0.png";